// Who registered on 1 webinar's register page (docs/replay-register-spec.md 5), at
// /admin/webinars/<id>/registrations: Name, Email, Registered, Source and Owns, newest first, with
// Download CSV in the house way (admin/ui/csv.js, which keeps anything a spreadsheet would run as a
// formula as text). hub.replay_registrations_for answers owner and admin only, as the people screens
// decide who sees emails, and refuses while viewing as a member. A table on a laptop; on a phone each row
// stacks into a card (admin/ui/Table.jsx). Test people are marked. Undrawn: no board has it.
import { useState } from 'react'
import { Link } from '../../lib/router.jsx'
import { Button, Crumbs, EmptyState, Loading, Problem, Table, downloadCsv, ukDateTime, adminPath, useLoad } from '../ui/index.js'
import { COPY } from './copy.js'
import { ownsWords, REGISTRATIONS_CSV } from './model.js'
import { loadRegistrations } from './data.js'

const OA = role => role === 'owner' || role === 'admin'

export function ReplayRegistrations({ webinar, api, role }) {
  const oa = OA(role)
  const id = webinar?.id || null
  const list = useLoad(() => (oa && id ? loadRegistrations(api, id) : Promise.resolve([])), [api, id, oa])
  const [downloaded, setDownloaded] = useState(false)

  const crumbs = (
    <Crumbs items={[
      { label: COPY.tabs.webinars, to: adminPath.webinars() },
      ...(webinar ? [{ label: webinar.title, to: adminPath.webinar(webinar.id) }] : []),
      { label: COPY.rrListTitle },
    ]} />
  )
  if (!webinar) return <>{crumbs}<div className="ad-card"><EmptyState>{COPY.rrListNoWebinar}</EmptyState></div></>
  if (!oa) return <>{crumbs}<div className="ad-card"><EmptyState>{COPY.rrListOnlyOwnerAdmin}</EmptyState></div></>

  const rows = list.data || []
  function csv() {
    downloadCsv(COPY.rrListCsvName(webinar.register_slug), REGISTRATIONS_CSV, rows)
    setDownloaded(true)
  }

  const columns = [
    {
      key: 'name', label: COPY.rrListHeads.name, width: 'minmax(0, 0.9fr)', primary: true,
      render: r => (
        <span className="adc-rr-name">
          {r.person_id ? <Link to={adminPath.person(r.person_id)} className="ad-td-main">{r.first_name}</Link> : <span className="ad-td-main">{r.first_name}</span>}
          {r.is_test && <span className="ad-tag">{COPY.rrListTest}</span>}
          {r.made_account && <span className="ad-td-sub">{COPY.rrListNewAccount}</span>}
        </span>
      ),
    },
    { key: 'email', label: COPY.rrListHeads.email, width: 'minmax(0, 1.2fr)', render: r => <span className="adc-break">{r.email}</span> },
    {
      key: 'registered', label: COPY.rrListHeads.registered, width: 'minmax(0, 1fr)',
      render: r => (
        <span className="adc-rr-when">
          <span>{ukDateTime(r.registered_at)}</span>
          {r.times_registered > 1 && <span className="ad-td-sub">{COPY.rrListTimes(r.times_registered, ukDateTime(r.last_registered_at))}</span>}
        </span>
      ),
    },
    { key: 'source', label: COPY.rrListHeads.source, width: 'minmax(0, 0.8fr)', render: r => <span className={r.source ? 'adc-break' : 'ad-td-quiet'}>{r.source || COPY.rrListNoSource}</span> },
    {
      key: 'owns', label: COPY.rrListHeads.owns, width: 'minmax(0, 1.2fr)',
      render: r => {
        const owns = ownsWords(r.owns)
        return owns.length
          ? <span className="adc-rr-owns">{owns.map(o => <span key={o} className="ad-tag">{o}</span>)}</span>
          : <span className="ad-td-quiet">{COPY.rrListOwnsNothing}</span>
      },
    },
  ]

  return (
    <>
      {crumbs}
      <section className="ad-card adc-rr-list" aria-labelledby="adc-rr-list-h">
        <div className="ad-card-head adc-rr-list-head">
          <span className="adc-rr-list-text">
            <h2 className="ad-card-title" id="adc-rr-list-h">{COPY.rrListTitle}</h2>
            <span className="ad-card-aside">{webinar.title}</span>
          </span>
          {rows.length > 0 && <Button size="sm" onClick={csv}>{downloaded ? COPY.rrListCsvDone : COPY.rrListCsv}</Button>}
        </div>
        {list.status === 'loading' && !list.data && <Loading />}
        {list.status === 'error' && !list.data && <Problem error={list.error} onRetry={list.reload} />}
        {list.data && (
          <>
            {!webinar.register_slug && <p className="adc-rr-count">{COPY.rrListNoLink}</p>}
            {rows.length > 0 && <p className="adc-rr-count">{COPY.rrListCount(rows.length)}</p>}
            <Table label={COPY.rrListTitle} rowKey={r => `${r.email}`} rows={rows} columns={columns} empty={COPY.rrListNone} flush />
          </>
        )}
      </section>
    </>
  )
}
